"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Archive = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Archive = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black50 : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { d: "M19.4,6 L13.7,6 L13,4 L17,4 C17.3,4 17.5,4.1 17.7,4.3 L19.4,6 Z M10.3,6 L4.6,6 L6.3,4.3 C6.5,4.1 6.7,4 7,4 L11,4 L10.3,6 Z M14,13 L14,7 L20,7 L20,19 C20,19.6 19.6,20 19,20 L5,20 C4.4,20 4,19.6 4,19 L4,7 L10,7 L10,13 L12,12 L14,13 Z", id: "ARCHIVE_SVG_ICON_PATH1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "ARCHIVE_ICON_SVG_MASK2", fill: "white" },
                React.createElement("use", { xlinkHref: "#ARCHIVE_SVG_ICON_PATH1" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#ARCHIVE_ICON_SVG_MASK2)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Archive = Archive;
//# sourceMappingURL=Archive.js.map